import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Smartphone } from "lucide-react";

const Frame = ({ children, to, onOpen, label, testid }) => {
  if (to) return <Link to={to} data-testid={testid} aria-label={label} className="block h-full w-full shrink-0 snap-center cursor-pointer">{children}</Link>;
  if (onOpen) return <button type="button" onClick={onOpen} data-testid={testid} aria-label={label} className="block h-full w-full shrink-0 snap-center cursor-zoom-in">{children}</button>;
  return <div className="h-full w-full shrink-0 snap-center">{children}</div>;
};

export const PhotoGallery = ({ images = [], alt, id, to, onOpen, dotsClass = "bottom-4 right-4" }) => {
  const ref = useRef(null);
  const [index, setIndex] = useState(0);
  const list = Array.isArray(images) ? images.filter(Boolean) : [];

  const go = (i) => {
    const el = ref.current;
    if (!el) return;
    const next = (i + list.length) % list.length;
    el.scrollTo({ left: next * el.clientWidth, behavior: "smooth" });
  };
  const onScroll = (e) => setIndex(Math.round(e.currentTarget.scrollLeft / e.currentTarget.clientWidth));

  const frame = (i) => ({ to, onOpen: onOpen && (() => onOpen(i)), label: onOpen ? `Ampliar foto ${i + 1}` : `Ver ${alt}`, testid: `product-photo-link-${id}-${i}` });

  if (!list.length) {
    return <Frame {...frame(0)} onOpen={null}><div className="relative flex h-full items-center justify-center"><Smartphone className="h-16 w-16 text-zinc-600" /></div></Frame>;
  }

  return (
    <div className="relative h-full">
      <div ref={ref} onScroll={onScroll} data-testid={`product-gallery-${id}`} className="no-scrollbar flex h-full snap-x snap-mandatory overflow-x-auto">
        {list.map((src, i) => (
          <Frame key={i} {...frame(i)}>
            <img src={src} alt={`${alt} - foto ${i + 1}`} loading="lazy" decoding="async" draggable={false} className="h-full w-full object-cover object-center transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]" />
          </Frame>
        ))}
      </div>
      {list.length > 1 && (
        <>
          <button data-testid={`product-gallery-prev-${id}`} onClick={() => go(index - 1)} aria-label="Foto anterior" className="absolute left-1.5 top-1/2 -translate-y-1/2 rounded-full bg-black/45 p-1 text-white backdrop-blur transition-opacity sm:left-3 sm:bg-black/60 sm:p-2 md:opacity-0 md:group-hover:opacity-100">
            <ChevronLeft className="h-3 w-3 sm:h-4 sm:w-4" />
          </button>
          <button data-testid={`product-gallery-next-${id}`} onClick={() => go(index + 1)} aria-label="Próxima foto" className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded-full bg-black/45 p-1 text-white backdrop-blur transition-opacity sm:right-3 sm:bg-black/60 sm:p-2 md:opacity-0 md:group-hover:opacity-100">
            <ChevronRight className="h-3 w-3 sm:h-4 sm:w-4" />
          </button>
          <div className={`pointer-events-none absolute flex gap-1.5 ${dotsClass}`}>
            {list.map((_, i) => (
              <span key={i} className={`h-1.5 rounded-full transition-all duration-500 ${i === index ? "w-5 bg-white" : "w-1.5 bg-white/50"}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
